export default "__VITE_ASSET__gt3tOBS3__"